import { create } from "zustand";
import { getBrands } from "../../lib/bigcommerce/restfull/apis/brandAPIS";
import { persist } from "zustand/middleware";

const useShopStore = create(
    persist(
        (set, get) => ({
            shopBrands: [],
            hasShopHydrated: false,

            getShopBrands: async () => {
                const { shopBrands } = get();
                if (shopBrands?.length > 0) return shopBrands;

                try {
                    const fetchedBrands = await getBrands();
                    set({ shopBrands: fetchedBrands });
                    return fetchedBrands;
                } catch (error) {
                    console.error("Failed to fetch brands:", error);
                    return [];
                }
            },
            setHasHydrated: (state) => {
                set({
                    hasShopHydrated: state,
                });
            },
        }),
        {
            name: "shop-store", // key for local storage
            getStorage: () => localStorage,
            onRehydrateStorage: (state) => {
                return () => state.setHasHydrated(true);
            },
        }
    )
);

export default useShopStore;
